import React from 'react';
interface Props {
  fillColor?: string;
}
function PodiatricIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none">
      <g clipPath="url(#clip0_847_3099)">
        <path
          d="M10.1156 1.95625C11.0969 1.70937 12.1969 1.5 13 1.5C14.2875 1.5 15.8062 1.83125 16.9531 2.40313C18.1875 3.02187 18.5 3.63438 18.5 4C18.5 4.29375 18.3406 4.67188 17.3781 5.03438C16.4594 5.38125 15.2844 5.5 14.5 5.5C13.4156 5.5 12.8281 5.175 11.9937 4.69688L11.9719 4.68437C11.3281 4.31562 10.5625 3.87812 9.5 3.65313V2.11875C9.6875 2.06563 9.89688 2.0125 10.1156 1.95625ZM8 5C9.5 5 10.375 5.5 11.25 6C12.125 6.5 13 7 14.5 7C16.2625 7 20 6.5 20 4C20 1.5 16 0 13 0C11.0094 0 8 1 8 1V3.5V5ZM4 3C4 4.10313 4.89687 5 6 5H7V1H6C4.89687 1 4 1.89688 4 3ZM6.11562 14.0437C5.89687 13.9875 5.6875 13.9344 5.5 13.8813V12.3469C6.5625 12.1188 7.32812 11.6813 7.97188 11.3156L7.99375 11.3031C8.82812 10.825 9.41562 10.5 10.5 10.5C11.2875 10.5 12.4594 10.6156 13.3781 10.9656C14.3406 11.3281 14.5 11.7063 14.5 12C14.5 12.3656 14.1875 12.9781 12.9531 13.5969C11.8062 14.1687 10.2875 14.5 9 14.5C8.19687 14.5 7.09687 14.2906 6.11562 14.0437ZM4 11V12.5V15C4 15 7.00938 16 9 16C12 16 16 14.5 16 12C16 9.5 12.2625 9 10.5 9C9 9 8.125 9.5 7.25 10C6.375 10.5 5.5 11 4 11ZM0 13C0 14.1031 0.896875 15 2 15H3V11H2C0.896875 11 0 11.8969 0 13Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3099">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PodiatricIcon;
